<era-device-grid-ui [devices]="devices()"
                    (selected)="selected.emit($event)">
  <div class="title">
    <h6>{{ title() }}</h6>
  </div>
  <div class="empty">
    <p>{{ emptyMessage() }}</p>
  </div>
</era-device-grid-ui>